module.exports = __webpack_public_path__ + "media/images/very_poor_star-16e507fb32e70f4b532ccb23378bd239.svg";